import type { RootState } from '../store';

export const selectBreakpoint = (state: RootState) => state.system.breakpoint;
// WHY: In fullscreen preview the canvas renders at real viewport width, so the active design
// breakpoint should track the viewport size rather than what the user last selected in the UI.
// This lets components render correctly as the window is resized across breakpoint thresholds,
// matching published page behaviour. selectBreakpoint is left unchanged for UI components
// (ResponsivePreviewNav etc.) that need the user's stored selection.
export const selectEffectiveBreakpoint = (state: RootState) =>
  state.system.isFullscreenPreview ? state.system.viewportBreakpoint : state.system.breakpoint;
export const selectPageWidth = (state: RootState) => state.system.pageWidth;
export const selectPageHeight = (state: RootState) => state.system.pageHeight;
export const selectSystemState = (state: RootState) => state.system;
export const selectObjectResizing = (state: RootState) => state.system.isObjectResizing;
export const selectPreviewModeEnabled = (state: RootState) => state.system.previewModeEnabled;
export const selectAnalyticsViewEnabled = (state: RootState) => state.system.analyticsViewEnabled;
export const selectPanelDragging = (state: RootState) => state.system.panelDragging;
export const selectNavbarTitleDropdownOpen = (state: RootState) =>
  state.system.isNavbarTitleDropdownOpen;
export const selectIsFullscreenPreview = (state: RootState) => state.system.isFullscreenPreview;
